import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {UsuariosContainer} from './Screen';

export const UsuariosView = () =>{

    return (
        <Page title={'Usuarios'}>{<UsuariosContainer/>}</Page>
    )
}